const marka = { t: 'Marka', name: 'marka', hint: { url: '/make/truck', cache: 'truck-make', exact: true }}
export default marka